import {
    useGetAccountInfo,
    sendTransactions,
    logout,
} from '@elrondnetwork/dapp-core'
import LoginComponent from 'components/Connect'
import { getWalletBodies } from 'helpers/asyncRequests'
import React from 'react'
import Nft from './NftComponent'
import StakedNft from './stakedNftComponent'
import fridgeImg from '../../luniImages/blankFridge.jpeg'
import './StableContent.css'
import {
    bigUint2hex,
    decodeAddress,
    int2hex,
    padBeforeString,
    str2hex,
    strNestedEncode,
} from 'helpers/encoding'
import { nftStakingSCAddress } from 'config'
import { getNftStakingData } from 'helpers/sqQueries'
import { BigUIntValue, U32Value } from '@elrondnetwork/erdjs/out'
import Logo from '../Logo'

const StableContent = () => {
    const [mounted, setMounted] = React.useState(false)
    //To simulate logging in and having some actual data, comment "useGetAccountInfo()" line and uncomment the address line
    const { address } = useGetAccountInfo()
    //const address = "erd1tztluf08g90max7jkr4jtac9w5qv7qacgkhh57q9nz2erq9y2p3sd5njkg";

    const loggedIn = Boolean(address)
    const [nfts, setNfts] = React.useState([])
    const [whatUserHasStaked, setWhatUserHasStaked] = React.useState({})
    const selectedNftIndexes = []
    const selectedStakedNfts = []

    const handleSelection = (arr, index) => {
        var arrIdx = arr.indexOf(index)
        if (arrIdx !== -1) {
            arr.splice(arrIdx, 1)
        } else {
            arr.push(index)
        }
    }

    React.useEffect(() => {
        if (!loggedIn || mounted) {
            return
        }
        Promise.all([
            getWalletBodies(address),
            getNftStakingData(address),
        ]).then(([data, stakedNfts]) => {
            if (!data.success) {
                return
            }
            setNfts(data.data)
            setWhatUserHasStaked(stakedNfts)
            console.log(stakedNfts)
            setMounted(true)
        })
    }, [loggedIn])

    const handleStake = async (e) => {
        e.preventDefault()
        if (selectedNftIndexes.length === 0) {
            window.alert('You need to select at least one NFT')
            return
        }
        let Selected = []
        selectedNftIndexes.forEach((index) => Selected.push(nfts[index]))

        let baseGasLimit = 35_000_000
        baseGasLimit += whatUserHasStaked.stakedNFTs.length * 2_000_000
        const gasPerNft = 5_000_000
        let transaction = {
            receiver: address,
            gasLimit: baseGasLimit,
            data: '',
            value: '0',
        }
        console.log(Selected)
        if (Selected.length > 1) {
            // multiEsdtNFTTransfer
            transaction.data = `MultiESDTNFTTransfer@${decodeAddress(
                nftStakingSCAddress
            )}@${int2hex(Selected.length)}`
            for (var i = 0; i < Selected.length; i++) {
                transaction.data += `@${str2hex(
                    Selected[i].collection
                )}@${int2hex(Selected[i].nonce)}@${int2hex(
                    Selected[i].quantity || 1
                )}`
                transaction.gasLimit += gasPerNft
            }
            transaction.data += `@${str2hex('stake')}`
        } else {
            //singleNFTTransfer
            transaction.data = `ESDTNFTTransfer@${str2hex(
                Selected[0].collection
            )}@${int2hex(Selected[0].nonce)}@${int2hex(
                Selected[0].quantity || 1
            )}@${decodeAddress(nftStakingSCAddress)}@${str2hex('stake')}`
            transaction.gasLimit += 2 * gasPerNft
        }
        console.log('parsed')

        const { sessionId, error } = await sendTransactions({
            transactions: [transaction],
            transactionsDisplayInfo: {
                processingMessage: 'Processing Stake NFTs transaction',
                errorMessage: 'An error has occured during staking',
                successMessage: 'Transaction successful',
                transactionDuration: 10000,
            },
        })
    }

    const claimRewards = async () => {
        let baseGasLimit = 35_000_000
        let gasLimit =
            baseGasLimit + whatUserHasStaked.stakedNFTs?.length * 2_000_000

        let transaction = {
            receiver: nftStakingSCAddress,
            gasLimit: gasLimit,
            data: 'claimRewards',
            value: '0',
        }
        const { sessionId /*, error*/ } = await sendTransactions({
            transactions: transaction,
            transactionsDisplayInfo: {
                processingMessage: 'Processing claim rewards transaction',
                errorMessage: 'An error has occured during claiming rewards',
                successMessage: 'Transaction successful',
                transactionDuration: 10000,
            },
        })
    }

    const handleUnstake = async (e) => {
        e.preventDefault()
        const baseGasLimit = 35_000_000
        const gasPerNft = 10_000_000
        let Selected = []
        selectedStakedNfts.forEach((index) =>
            Selected.push(whatUserHasStaked.stakedNFTs[index])
        )
        if (Selected.length > 0) {
            let transaction = {
                receiver: nftStakingSCAddress,
                gasLimit: baseGasLimit,
                data: '',
                value: '0',
            }
            transaction.data = `unstake`
            for (var i = 0; i < Selected.length; i++) {
                let token = strNestedEncode(Selected[i].tokenIdentifier)
                let qty = bigUint2hex(
                    new BigUIntValue(
                        new U32Value(Selected[i].quantity || 1).value
                    )
                )
                let nonce = padBeforeString(int2hex(Selected[i].nonce), 16)
                transaction.data += `@${token}${nonce}${qty}`
                transaction.gasLimit += gasPerNft
            }
            // console.log(transaction.data);
            // return;
            const { sessionId /*, error*/ } = await sendTransactions({
                transactions: transaction,
                transactionsDisplayInfo: {
                    processingMessage: 'Processing NFT Unstake transaction',
                    errorMessage: 'An error has occured during unstaking',
                    successMessage: 'Transaction successful',
                    transactionDuration: 10000,
                },
            })
        } else {
            window.alert('You must select at least one NFT!')
        }
    }

    const handleLogout = (e) => {
        e.preventDefault()
        logout(`${window.location.origin}/`)
    }

    return !loggedIn ? (
        <LoginComponent />
    ) : (
        mounted && (
            <>
                <div className="staked">
                    <Logo />
                    <img src={fridgeImg} alt="fridge" className="staked__img" />
                    <div className="staked-not-yet">
                        <h3>Select NFT's to stake</h3>
                        <button onClick={handleStake}>
                            Stake selected NFTs
                        </button>
                        <div className="position-relative">
                            <div className="staked-not-yet__nft-container">
                                {nfts.map((data, index) => {
                                    return (
                                        <Nft
                                            key={index}
                                            imgSrc={data.url}
                                            tokenIdentifier={
                                                data.tokenIdentifier
                                            }
                                            onClickHandle={() =>
                                                handleSelection(
                                                    selectedNftIndexes,
                                                    index
                                                )
                                            }
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="staked-already">
                        <h3>
                            Staked Lunicorns ({whatUserHasStaked.rewardsPerDay}{' '}
                            $NGMI/day)
                        </h3>
                        <div className="staked-already__buttons">
                            {whatUserHasStaked.claimableRewards > 0 && (
                                <button
                                    className="highlight"
                                    onClick={claimRewards}
                                >
                                    Claim {whatUserHasStaked.claimableRewards}{' '}
                                    $NGMI
                                </button>
                            )}
                            <button onClick={handleUnstake}>
                                Unstake selected NFTs
                            </button>
                        </div>
                        <div className="position-relative">
                            <div className="staked-already__nft-container">
                                {whatUserHasStaked.stakedNFTs.length > 0 && (
                                    <>
                                        {whatUserHasStaked.stakedNFTs.map(
                                            (data, index) => {
                                                return (
                                                    <StakedNft
                                                        key={index}
                                                        nft={data}
                                                        onClickHandle={() =>
                                                            handleSelection(
                                                                selectedStakedNfts,
                                                                index
                                                            )
                                                        }
                                                    />
                                                )
                                            }
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="disconnect">
                        <button onClick={handleLogout}>Logout</button>
                    </div>
                </div>
            </>
        )
    )
}

export default StableContent
